import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24799da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-12 text-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left text-primary" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card shadow-sm mb-5" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title text-gray-800" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1))
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "fs-4 text-gray-700",
  style: {"white-space":"pre-line"}
}
const _hoisted_11 = {
  key: 1,
  class: "fs-4 text-gray-700"
}
const _hoisted_12 = { class: "row gx-5 mb-5 order-1" }
const _hoisted_13 = { class: "col-lg-12" }
const _hoisted_14 = { class: "card card-xl-stretch" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "card-title text-gray-800" }
const _hoisted_17 = { class: "card-toolbar" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-play-circle text-primary" }, null, -1))
const _hoisted_19 = { class: "" }
const _hoisted_20 = {
  key: 1,
  class: "btn-disabled-countdown text-gray-500 border border-gray-500"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle text-gray-500 me-1" }, null, -1))
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = {
  key: 0,
  class: "fs-4 text-gray-700"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_26 = {
  key: 1,
  class: "fs-4 text-gray-700"
}
const _hoisted_27 = {
  key: 0,
  class: "card-footer"
}
const _hoisted_28 = { class: "d-flex flex-center justify-content-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "row d-inline-flex justify-content-around text-success" }
const _hoisted_31 = { class: "col px-0 mx-2" }
const _hoisted_32 = { class: "text-gray-700" }
const _hoisted_33 = { class: "number fw-bold" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", { class: "number" }, ":")
], -1))
const _hoisted_35 = { class: "col px-0 mx-2" }
const _hoisted_36 = { class: "text-gray-700" }
const _hoisted_37 = { class: "number fw-bold" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", { class: "number" }, ":")
], -1))
const _hoisted_39 = { class: "col px-0 mx-2" }
const _hoisted_40 = { class: "text-gray-700" }
const _hoisted_41 = { class: "number fw-bold" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", { class: "number" }, ":")
], -1))
const _hoisted_43 = { class: "col px-0 mx-2" }
const _hoisted_44 = { class: "text-gray-700" }
const _hoisted_45 = { class: "number fw-bold" }
const _hoisted_46 = {
  key: 0,
  class: "row gap-2 gap-lg-0 order-2"
}
const _hoisted_47 = { class: "col-lg-6" }
const _hoisted_48 = { class: "card card-xl-stretch h-100" }
const _hoisted_49 = { class: "card-header" }
const _hoisted_50 = { class: "card-title text-gray-800" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip text-success me-2" }, null, -1))
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "text-gray-700" }
const _hoisted_54 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm text-primary" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  key: 1,
  class: "text-muted text-center py-4"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1))
const _hoisted_59 = {
  key: 2,
  class: "d-flex flex-column gap-2"
}
const _hoisted_60 = {
  class: "d-flex align-items-center",
  style: {"min-width":"0"}
}
const _hoisted_61 = { style: {"min-width":"0"} }
const _hoisted_62 = ["title"]
const _hoisted_63 = { class: "text-muted fs-8" }
const _hoisted_64 = {
  key: 0,
  class: "me-2"
}
const _hoisted_65 = { key: 1 }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download" }, null, -1))
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = { class: "col-lg-6" }
const _hoisted_70 = { class: "card card-xl-stretch h-100" }
const _hoisted_71 = { class: "card-header" }
const _hoisted_72 = { class: "card-title text-gray-800" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload text-primary me-2" }, null, -1))
const _hoisted_74 = { class: "card-body" }
const _hoisted_75 = { class: "text-gray-700 mb-3" }
const _hoisted_76 = { class: "mb-3" }
const _hoisted_77 = {
  key: 0,
  class: "form-text text-success mt-2"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle me-1" }, null, -1))
const _hoisted_79 = {
  key: 1,
  class: "form-text text-muted mt-2"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1))
const _hoisted_81 = {
  key: 1,
  class: "row mt-5"
}
const _hoisted_82 = { class: "col-12" }
const _hoisted_83 = { class: "card shadow-sm" }
const _hoisted_84 = { class: "card-body text-center py-8" }
const _hoisted_85 = { class: "text-gray-800 mb-4" }
const _hoisted_86 = { class: "text-gray-600 mb-5" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_89 = {
  key: 1,
  class: "bi bi-upload me-2"
}
const _hoisted_90 = {
  key: 0,
  class: "text-muted mt-3 mb-0"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle me-1" }, null, -1))
const _hoisted_92 = {
  key: 1,
  class: "row d-flex justify-content-center"
}
const _hoisted_93 = {
  class: "card shadow-sm w-full",
  style: {"height":"613px"}
}
const _hoisted_94 = { class: "card-body" }
const _hoisted_95 = { class: "text-center" }
const _hoisted_96 = { class: "container text-center mt-5" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_98 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }
const _hoisted_99 = {
  key: 1,
  class: "d-flex flex-column py-6"
}
const _hoisted_100 = { class: "container text-center mt-5" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_102 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }

import {computed, onMounted, ref, onBeforeUnmount} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import Swal from "sweetalert2";
import moment from "moment";
import {useCertificationSteps} from "@/core/composables/useCertificationSteps";
import {formatBrasilia} from "@/core/helpers/dates";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



const store = useStore();
const router = useRouter();

const {
  loadCertificationData,
  statusData,
  currentStep,
  expectedStepForComponent,
  configData,
  getStepByType,
} = useCertificationSteps(props.id, 'certification_modeling');

const modelingStep = computed(() => getStepByType('modeling'));
const modelingTitle = computed(() => modelingStep.value?.title?.trim() || null);
const modelingMessage = computed(() => modelingStep.value?.message?.trim() || null);

// Início do step vem direto do backend (current_step_started_at), com fallback no created_at
const modelingStartedAtText = computed(() => {
  const startedAt = statusData.value?.current_step_started_at ?? statusData.value?.created_at;
  return startedAt ? formatBrasilia(startedAt) : '00/00/0000 00:00';
});
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const loading = ref(false);
const certificationStarted = ref(false);
const referenceAttachments = ref<Array<{
  attachment_id: number;
  name: string;
  mime_type: string | null;
  file_size: number | null;
  type: string | null;
  language: string | null;
  download_url: string;
  expires_at: string | null;
}>>([]);
const loadingAttachments = ref(false);
const selectedFile = ref<File | null>(null);
const uploadLoading = ref(false);
const modelingDeadline = ref<string>("");
const timeRemaining = ref({ days: 0, hours: 0, minutes: 0, seconds: 0 });
const intervalId = ref<number | null>(null);
const showCountdown = ref(false);

onBeforeUnmount(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
  }
});

const calculateTimeRemaining = () => {
  if (!modelingDeadline.value) {
    timeRemaining.value = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return;
  }

  const now = new Date();
  const end = moment.utc(modelingDeadline.value).toDate();
  const difference = end.getTime() - now.getTime();

  if (difference > 0) {
    timeRemaining.value = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  } else {
    timeRemaining.value = { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
};

const startCountdown = () => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
  }
  
  calculateTimeRemaining();
  intervalId.value = window.setInterval(() => {
    calculateTimeRemaining();
  }, 1000);
};

onMounted(async () => {
  loading.value = true;
  try {
    showCountdown.value = false;
    
    // Carrega configuração e status da certificação usando o composable
    await loadCertificationData();
    
    // Verifica se statusData foi carregado
    if (statusData.value) {
      // Verifica se está no step esperado para modelagem ou além
      const isStarted = currentStep.value >= (expectedStepForComponent.value || 1);
      
      if (isStarted) {
        certificationStarted.value = true;
        if (statusData.value.certification_data?.modeling_deadline) {
          modelingDeadline.value = statusData.value.certification_data.modeling_deadline;
          startCountdown();
        }
        await loadReferenceAttachments();
      }
    }
  } catch (e) {
    console.error("Erro ao buscar o status:", e);
  } finally {
    loading.value = false;
    showCountdown.value = true;
  }
});

const startCertification = async () => {
  loading.value = true;
  try {
    // Inicia o deadline no backend (backend calcula baseado em deadline_days do step)
    const response = await ApiService.get(`/certification/start-deadline/${props.id}`);
    if (response.data.success) {
      certificationStarted.value = true;
      
      // Avança para o próximo step
      await ApiService.post(`/certification/${props.id}/advance-step`);
      
      // Recarrega os dados para obter o deadline atualizado
      await loadCertificationData();
      
      // Busca o modeling_deadline atualizado
      if (statusData.value?.certification_data?.modeling_deadline) {
        modelingDeadline.value = statusData.value.certification_data.modeling_deadline;
        startCountdown();
      }
      
      // Faz refresh na página
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  } catch (e) {
    console.error("Erro ao iniciar certificação:", e);
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: store.getters.getCurrentLanguageTranslation?.certification?.modeling?.error_start || 'Erro ao iniciar certificação.',
    });
  } finally {
    loading.value = false;
  }
};

const advanceStep = async () => {
  if (!selectedFile.value) {
    Swal.fire({
      icon: 'warning',
      title: store.getters.getCurrentLanguageTranslation?.certification?.modeling?.attention || 'Atenção',
      text: store.getters.getCurrentLanguageTranslation?.certification?.modeling?.select_file_first || 'Por favor, selecione um arquivo primeiro.',
    });
    return;
  }

  loading.value = true;
  try {
    // Primeiro faz o upload do arquivo
    const formData = new FormData();
    formData.append('file', selectedFile.value);

    await ApiService.post(`/certification/${props.id}/upload-threat-modeling`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    // Depois avança o step
    await ApiService.post(`/certification/${props.id}/advance-step`);
    
    Swal.fire({
      icon: 'success',
      title: 'Sucesso!',
      text: 'Modelagem enviada com sucesso. Avançando para próxima etapa...',
      showConfirmButton: false,
      timer: 2000
    });

    setTimeout(() => {
      window.location.reload();
    }, 2000);
  } catch (e) {
    console.error("Erro ao avançar etapa:", e);
    Swal.fire({
      title: "Oops...",
      text: e.response?.data?.message || 'Erro ao processar a solicitação. Por favor, tente novamente mais tarde.',
      icon: "warning",
      confirmButtonText: "Ok",
    });
  } finally {
    loading.value = false;
  }
};

const loadReferenceAttachments = async () => {
  loadingAttachments.value = true;
  try {
    const response = await ApiService.get(`/certification/${props.id}/attachments/modeling`);
    const list = response.data.attachments ?? [];
    referenceAttachments.value = Array.isArray(list) ? list : [];
  } catch (e) {
    console.error("Erro ao carregar anexos de referência:", e);
    referenceAttachments.value = [];
  } finally {
    loadingAttachments.value = false;
  }
};

const downloadAttachment = (attachment) => {
  if (attachment?.download_url) {
    window.open(attachment.download_url, '_blank');
  }
};

const attachmentIcon = (mime: string | null) => {
  if (!mime) return 'bi-file-earmark';
  if (mime === 'application/pdf') return 'bi-file-pdf';
  if (mime.startsWith('image/')) return 'bi-file-image';
  if (mime.startsWith('video/')) return 'bi-file-play';
  if (mime.startsWith('audio/')) return 'bi-file-music';
  if (mime.includes('zip') || mime.includes('compressed') || mime.includes('tar') || mime.includes('7z')) return 'bi-file-zip';
  if (mime.includes('text') || mime.includes('json') || mime.includes('xml') || mime.includes('javascript')) return 'bi-file-code';
  return 'bi-file-earmark';
};

const formatFileSize = (bytes: number | null) => {
  if (!bytes && bytes !== 0) return '';
  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let i = 0;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }
  return `${size.toFixed(size >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
};

const handleFileSelect = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    selectedFile.value = target.files[0];
  }
};

const uploadThreatModeling = async () => {
  if (!selectedFile.value) {
    Swal.fire({
      icon: 'warning',
      title: store.getters.getCurrentLanguageTranslation?.certification?.modeling?.attention || 'Atenção',
      text: store.getters.getCurrentLanguageTranslation?.certification?.modeling?.select_file_first || 'Por favor, selecione um arquivo primeiro.',
    });
    return;
  }

  uploadLoading.value = true;
  try {
    const formData = new FormData();
    formData.append('file', selectedFile.value);

    const response = await ApiService.post(`/certification/${props.id}/upload-threat-modeling`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    Swal.fire({
      icon: 'success',
      title: 'Sucesso!',
      text: 'Modelagem enviada com sucesso.',
      showConfirmButton: false,
      timer: 2000
    });

    // Limpa o arquivo selecionado após o upload
    selectedFile.value = null;
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  } catch (e) {
    console.error("Erro ao enviar modelagem de ameaças:", e);
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: store.getters.getCurrentLanguageTranslation?.certification?.modeling?.error_upload || 'Erro ao fazer upload do arquivo.',
    });
  } finally {
    uploadLoading.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'certifications' },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.back`)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(modelingTitle) ?? _ctx.$t(`${_unref(currentLanguage)}.certification.modeling.title`)), 1),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(modelingMessage))
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(modelingMessage)), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.description`)), 1))
            ])
          ]),
          (showCountdown.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline`)), 1),
                        _createElementVNode("div", _hoisted_17, [
                          (!certificationStarted.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: startCertification,
                                class: "btn btn-sm btn-light-primary text-primary text-hover-white"
                              }, [
                                _hoisted_18,
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.start_certification`)), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _hoisted_21,
                                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.certification_started`)), 1)
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        (certificationStarted.value && modelingDeadline.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                              _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.deadline_started_at`)) + " ", 1),
                              _createElementVNode("b", null, _toDisplayString(_unref(modelingStartedAtText)) + "h", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.and_ends_at`)) + " ", 1),
                              _createElementVNode("b", null, _toDisplayString(_unref(formatBrasilia)(modelingDeadline.value)) + "h", 1),
                              _hoisted_25
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.click_to_start`)), 1))
                      ]),
                      (certificationStarted.value && modelingDeadline.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.day`)), 1),
                                    _createElementVNode("div", _hoisted_33, _toDisplayString(timeRemaining.value.days.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_34,
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hours`)), 1),
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(timeRemaining.value.hours.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_38,
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.minutes`)), 1),
                                    _createElementVNode("div", _hoisted_41, _toDisplayString(timeRemaining.value.minutes.toString().padStart(2, '0')), 1)
                                  ]),
                                  _hoisted_42,
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.seconds`)), 1),
                                    _createElementVNode("div", _hoisted_45, _toDisplayString(timeRemaining.value.seconds.toString().padStart(2, '0')), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (certificationStarted.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("h3", _hoisted_50, [
                              _hoisted_51,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.reference_attachments`)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.reference_attachments_desc`)), 1),
                            (loadingAttachments.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, _hoisted_56))
                              : (referenceAttachments.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _hoisted_58,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.no_attachments`)), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(referenceAttachments.value, (att) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: att.attachment_id,
                                        class: "d-flex align-items-center justify-content-between p-3 bg-light bg-opacity-10 rounded border border-gray-700"
                                      }, [
                                        _createElementVNode("div", _hoisted_60, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(['bi', attachmentIcon(att.mime_type), 'text-success me-2 fs-3'])
                                          }, null, 2),
                                          _createElementVNode("div", _hoisted_61, [
                                            _createElementVNode("div", {
                                              class: "text-gray-800 fw-bold text-truncate",
                                              title: att.name
                                            }, _toDisplayString(att.name), 9, _hoisted_62),
                                            _createElementVNode("div", _hoisted_63, [
                                              (att.mime_type)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(att.mime_type), 1))
                                                : _createCommentVNode("", true),
                                              (att.file_size)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(formatFileSize(att.file_size)), 1))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-sm btn-light-success ms-3",
                                          onClick: ($event: any) => (downloadAttachment(att))
                                        }, _hoisted_68, 8, _hoisted_66)
                                      ]))
                                    }), 128))
                                  ]))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("h3", _hoisted_72, [
                              _hoisted_73,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.upload_modeling`)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.upload_modeling_desc`)), 1),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("input", {
                                id: "fileInput",
                                type: "file",
                                onChange: handleFileSelect,
                                accept: ".pdf,.png,.jpg,.jpeg",
                                class: "form-control"
                              }, null, 32),
                              (selectedFile.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                    _hoisted_78,
                                    _createTextVNode(" " + _toDisplayString(selectedFile.value.name), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                    _hoisted_80,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.select_file_to_continue`) || 'Selecione o arquivo para continuar'), 1)
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (certificationStarted.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("h4", _hoisted_85, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.advance_step_title`) || 'Pronto para enviar e avançar?'), 1),
                            _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.advance_step_description`) || 'Selecione o arquivo de modelagem acima e clique no botão abaixo para enviar e avançar para a próxima etapa.'), 1),
                            _createElementVNode("button", {
                              onClick: advanceStep,
                              disabled: loading.value || !selectedFile.value,
                              class: "btn btn-lg btn-primary"
                            }, [
                              (loading.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_88))
                                : (_openBlock(), _createElementBlock("i", _hoisted_89)),
                              _createTextVNode(" " + _toDisplayString(loading.value ? (_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.processing`) || 'Processando...') : (_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.submit_and_advance`) || 'Enviar e Avançar para Próxima Etapa')), 1)
                            ], 8, _hoisted_87),
                            (!selectedFile.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_90, [
                                  _hoisted_91,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.file_required`) || 'Selecione um arquivo antes de enviar'), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                _createElementVNode("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _hoisted_97,
                        _createElementVNode("span", _hoisted_98, "   " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.modeling.loading_info`)) + "...", 1)
                      ])
                    ])
                  ])
                ])
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _hoisted_101,
            _createElementVNode("span", _hoisted_102, "   " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.analyzing_the_requirements`)) + "...", 1)
          ])
        ]))
  ], 64))
}
}

})